import { ReactNode } from 'react';
import { Skeleton } from '@mui/material';
import { colors } from '../../../styles/colors';

interface LoadingWrapperProps {
  isLoading: boolean;
  skeletonHeight?: number;
  skeletonWidth?: string | number;
  children: ReactNode;
}

export const LoadingWrapper = ({
  isLoading,
  skeletonHeight = 80,
  skeletonWidth = '100%',
  children,
}: LoadingWrapperProps) => {
  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={skeletonHeight}
        width={skeletonWidth}
        sx={{
          bgcolor: colors.background.secondary,
          mb: 3,
          borderRadius: 2,
        }}
      />
    );
  }

  return <>{children}</>;
};
